export const SERVER_URL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_SERVER_URL
